export const EventListenerMixin = (type, callback) => ({
    mounted() {
        this[callback]();
        window.addEventListener(type, this[callback]);
    },

    beforeDestroy() {
        window.removeEventListener(type, this[callback]);
    }
});


// WEBPACK FOOTER //
// ./src/mixins/EventListenerMixin.js